module.exports = __webpack_public_path__ + "static/media/Date.612a71ea.svg";